const LINKS = [
  {
    path: "/",
    text: "Home",
  },
  {
    path: "/newsroom",
    text: "Newsroom",
  },
];

const CASESTUDY_LINKS = [
  {
    path: "/",
    text: "Home",
  },
  {
    path: "/case-studies",
    text: "Case Studies",
  },
];

export { LINKS, CASESTUDY_LINKS };
